import React from 'react';
import { PhotoCardPlaceholder, Spinner } from './styled';
import { PhotoButton } from '../../ItemCreationForm/AddNewItemForm/components/GalleryItem/styled';
import { PhotoButtonEnum } from '../../ItemCreationForm/AddNewItemForm/components/GalleryItem/types';

interface PhotoPlaceholderProps {
  handleDelete: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

export const PhotoPlaceholder: React.FC<PhotoPlaceholderProps> = ({
  handleDelete
}) => (
  <PhotoCardPlaceholder>
    <PhotoButton
      onClick={handleDelete}
      iconType={PhotoButtonEnum.Delete}
      aria-label="Delete photo"
    />
    <Spinner />
  </PhotoCardPlaceholder>
);
